/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const AlignJustifyIconConfig = {
  name: 'AlignJustifyIcon',
  height: 512,
  width: 448,
  svgPath: 'M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(AlignJustifyIconConfig);
//# sourceMappingURL=align-justify-icon.js.map